import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import moment from "moment/moment";
import {getByAtribute} from "../../../../utils/formatar";
import _ from "lodash";
import FluxoProrrogacaoStore from "./FluxoProrrogacaoStore";


export default class AndamentoProrrogacaoStore extends FluxoProrrogacaoStore {

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
    }

    getSolicitacao(dadosUrl) {
        const solicitacaoEttId = dadosUrl.solicitacaoEttId;
        const prorrogacaoId = parseInt(dadosUrl.prorrogacaoId.replace("PR", ""));
        this.idFluxo = dadosUrl.idFluxo;

        this.nomeFluxo = "SolicitacaoProrrogacao";
        this.nomeTarefa = "HT_AvaliacaoSolicitacao";
        this.loadingPanelStore.setIsLoading("AndamentoProrrogacaoLoading", true);

        let promise = (this.idFluxo !== undefined) 
                        ? this.fluxoService.carregarDetalhesSolicitacaoByProrrogacaoId(solicitacaoEttId, prorrogacaoId)
                        : this.solicitacaoService.carregarDetalhesSolicitacaoByProrrogacaoId(solicitacaoEttId, prorrogacaoId);

        promise.then(response => {

            this.handleSolicitacaoPorId(response.data.solicitacao, !!dadosUrl.solicitacaoEttId, false);
            this.handleSolicitacaoEttById(response.data.solicitacaoEtt, false, prorrogacaoId);
            this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);

            this.carregarDadosProrrogacoesAnteriores();
            this.idFluxo = response.data.idFluxo;
            this.carregarDadosExtras(response.data, "andamentoProrrogacao", dadosUrl);

            this.loadingPanelStore.setIsLoading("AndamentoProrrogacaoLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("AndamentoProrrogacaoLoading", false);
        });
    }

}